/* eslint-disable camelcase */
import {
  post, get, destroy, put,
} from './index';
import cleanUpObject from '../cleanUpObject';

/**
     * Send request to create a new visit
     * @param {object} formData visit data
     * @param {number} orgId organization id
     * @returns Promise with http response
     */
export const createVisit = (formData, orgId) => {
  const { distributed_items, ...rest } = formData;
  const data = { visit: { ...rest, distributed_items_attributes: distributed_items } };
  return post(`/api/v1/visits?organization_id=${orgId}`, data);
};

/**
 * Send request to get visits
 * @param {number} orgId organization id
 * @param {object} params api params for searching by name, start and end date
 * @returns Promise with http response regarding getting visits
 */
export const getVisits = (orgId, params = {}) => {
  const {
    visitName = '',
    visitsStartDate = '',
    visitsEndDate = '',
    sortBy = 'date',
    direction = 'desc',
  } = params;
  const queryParamString = new URLSearchParams({
    name: visitName,
    start_date: visitsStartDate,
    end_date: visitsEndDate,
    sortBy,
    direction,
    organization_id: orgId,
    ...params,
  }).toString();

  return get(`/api/v1/visits?${queryParamString}`);
};

export const deleteVisit = (organizationId, id) => destroy(`/api/v1/visits/${id}?organization_id=${organizationId}`);

export const getVisit = async (organizationId, id) => {
  const resp = await get(`/api/v1/visits/${id}?organization_id=${organizationId}`);
  return resp.json();
};

export const updateVisit = (formData, organizationId, visitId) => {
  const { distributed_items, ...rest } = formData;
  const data = { visit: { ...rest, distributed_items_attributes: distributed_items } };
  return put(`/api/v1/visits/${visitId}?organization_id=${organizationId}`, data);
};

export const getVisitsPage = (organizationId, params) => {
  let queryParamString = {
    organization_id: organizationId,
    site_name: params.site_name || '',
    date: params.date || '',
    leader: params.leader || '',
    keyword: params.keyword || '',
    from: params.from || '',
    to: params.to || '',
    purpose: params.purpose || '',
    total_workers: params.total_workers || '',
    workers_interacted: params.workers_interacted || '',
    completed: params.completed !== undefined ? params.completed : '',
    sort: params.sortBy || '',
    ordering: params.direction || '',
    per_page: params.per_page || 9,
    page: params.page || 0,
    product_id: params.product_id || '',
  };
  cleanUpObject(queryParamString);
  queryParamString = new URLSearchParams(queryParamString).toString();
  return get(`/api/v1/visits?${queryParamString}`);
};
